/* eslint-disable jsx-a11y/anchor-is-valid */
import { Stack } from 'react-bootstrap'
import { StepProps } from '../IAppModels'

const Step4 = ({ data, updateData }: StepProps) => {
  return (
    <>
      <div data-kt-stepper-element='content'>
        <div
          className='w-100'
          style={{ overflowX: 'hidden', overflowY: 'auto', paddingRight: '10px' }}
        >
          {/*begin::Form Group */}
          <div className='fv-row'>
            <div className='fv-row'>
              <Stack direction='horizontal'>
                <label className='fs-5 fw-bold mb-2'>
                  <span className='fs-3'>Notes</span>
                </label>
              </Stack>
            </div>
            <div className='fv-row'>
              <div className='mt-1 float-right text-end mr-3'>
                {data?.notesInfo?.inputText?.length} of 2000
              </div>
              <textarea
                name='businessDescription'
                className='form-control form-control-lg form-control-solid resize-none min-h-300px'
                value={data.notesInfo.inputText}
                placeholder='Enter Notes'
                maxLength={2000}
                onChange={(e) =>
                  updateData({
                    notesInfo: {
                      inputText: e.target.value,
                    },
                    // eslint-disable-next-line no-sequences
                  })
                }
                rows={3}
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { Step4 }
